/**
 * Marks an element as a chat surface.
 *
 * The dialog provider queries for it to decide whether a click
 * landed inside a chat, and every shell stamps it on the element it
 * paints. Both sides read it from here so the attribute name is
 * declared once.
 */
export const CHAT_SURFACE_ATTR = 'data-chat-surface';
